// extracted by mini-css-extract-plugin
export default {"header":"AppReviewSearch__header--slots-T4MCy"};